import { PERMISSIONS_ACTIONS, PERMISSIONS_NAMES } from './permissions';

export const READ_PERMISSIONS = Object.freeze([
  PERMISSIONS_ACTIONS.READ,
  PERMISSIONS_ACTIONS.WALLET_COMPLETE_READ,
  PERMISSIONS_ACTIONS.WALLET_COMPLETE_READ_2,
  PERMISSIONS_ACTIONS.COMPLETE_READ,
  PERMISSIONS_ACTIONS.WALLET_BROKER_READ,
  PERMISSIONS_ACTIONS.WALLET_BROKER_READ_2,
  PERMISSIONS_ACTIONS.WALLET_CONSULTANCY_READ,
  PERMISSIONS_ACTIONS.WALLET_CONSULTANCY_READ_2,
  PERMISSIONS_ACTIONS.WALLET_COVENANT_READ,
  PERMISSIONS_ACTIONS.WALLET_COVENANT_READ_2,
]);

const DASHBOARD_PERMISSIONS = Object.freeze([
  {
    action: PERMISSIONS_ACTIONS.WALLET_COMPLETE_READ,
    subject: PERMISSIONS_NAMES.DASHBOARD,
  },
  {
    action: PERMISSIONS_ACTIONS.WALLET_CONSULTANCY_READ,
    subject: PERMISSIONS_NAMES.DASHBOARD,
  },
  {
    action: PERMISSIONS_ACTIONS.WALLET_COVENANT_READ,
    subject: PERMISSIONS_NAMES.DASHBOARD,
  },
  {
    action: PERMISSIONS_ACTIONS.WALLET_BROKER_READ,
    subject: PERMISSIONS_NAMES.DASHBOARD,
  },
  {
    action: PERMISSIONS_ACTIONS.FINANCIAL_COMPLETE_READ,
    subject: PERMISSIONS_NAMES.DASHBOARD,
  },
  {
    action: PERMISSIONS_ACTIONS.FINANCIAL_READ,
    subject: PERMISSIONS_NAMES.DASHBOARD,
  },
]);

const INSUREDS_READ_PERMISSIONS = Object.freeze([
  {
    action: PERMISSIONS_ACTIONS.READ,
    subject: PERMISSIONS_NAMES.INSUREDS,
  },
  {
    action: PERMISSIONS_ACTIONS.WALLET_COMPLETE_READ,
    subject: PERMISSIONS_NAMES.INSUREDS,
  },
]);

const INSURED_DETAIL_READ_PERMISSIONS = Object.freeze([
  ...DASHBOARD_PERMISSIONS,
  ...INSUREDS_READ_PERMISSIONS,
  {
    action: PERMISSIONS_ACTIONS.READ,
    subject: PERMISSIONS_NAMES.FINANCIAL_PANEL,
  },
  {
    action: PERMISSIONS_ACTIONS.WRITE,
    subject: PERMISSIONS_NAMES.EVENTS,
  },
  {
    action: PERMISSIONS_ACTIONS.WRITE,
    subject: PERMISSIONS_NAMES.CLOSING,
  },
  {
    action: PERMISSIONS_ACTIONS.READ,
    subject: PERMISSIONS_NAMES.CONSOLIDATED,
  },
]);

export const ROUTER_PERMISSIONS = Object.freeze({
  INSURED_DETAIL: INSURED_DETAIL_READ_PERMISSIONS,
  EVENTS: [
    {
      action: PERMISSIONS_ACTIONS.WRITE,
      subject: PERMISSIONS_NAMES.EVENTS,
    },
  ],
  QUOTATION_NEW: [
    {
      action: PERMISSIONS_ACTIONS.WRITE,
      subject: PERMISSIONS_NAMES.QUOTATIONS,
    },
  ],
  QUOTATION_DETAIL: [
    {
      action: PERMISSIONS_ACTIONS.READ,
      subject: PERMISSIONS_NAMES.QUOTATIONS,
    },
    {
      action: PERMISSIONS_ACTIONS.WALLET_COMPLETE_READ,
      subject: PERMISSIONS_NAMES.QUOTATIONS,
    },
  ],
  INSPECTION_DETAIL: [
    ...INSURED_DETAIL_READ_PERMISSIONS,
    {
      action: PERMISSIONS_ACTIONS.READ,
      subject: PERMISSIONS_NAMES.INSPECTIONS,
    },
    {
      action: PERMISSIONS_ACTIONS.WALLET_COMPLETE_READ,
      subject: PERMISSIONS_NAMES.INSPECTIONS,
    },
    {
      action: PERMISSIONS_ACTIONS.APPROVE_WITHOUT_INSPECTION,
      subject: PERMISSIONS_NAMES.QUOTATIONS,
    },
    {
      action: PERMISSIONS_ACTIONS.SHOW_INSPECTION,
      subject: PERMISSIONS_NAMES.QUOTATIONS,
    },
  ],
  MESSAGING_EDIT: [
    {
      action: PERMISSIONS_ACTIONS.WRITE,
      subject: PERMISSIONS_NAMES.MESSAGING,
    },
  ],
  SUPPLIER_TYPES: [
    {
      action: PERMISSIONS_ACTIONS.SUPPLIER_TYPES,
      subject: PERMISSIONS_NAMES.SUPPLIER,
    },
  ],
  STATUS_EDIT: [
    {
      action: PERMISSIONS_ACTIONS.WRITE,
      subject: PERMISSIONS_NAMES.STATUS_CHANGE,
    },
  ],
  VEHICLES_GROUP_ASSOCIATE_ACCESSORIES: [
    {
      action: PERMISSIONS_ACTIONS.ASSOCIATE_ACCESSORIES,
      subject: PERMISSIONS_NAMES.VEHICLES_GROUP,
    },
  ],
  VEHICLES_GROUP_ASSOCIATE_MODELS: [
    {
      action: PERMISSIONS_ACTIONS.ASSOCIATE_MODELS,
      subject: PERMISSIONS_NAMES.VEHICLES_GROUP,
    },
  ],
  TABLES_VALUES: [
    {
      action: PERMISSIONS_ACTIONS.VALUES,
      subject: PERMISSIONS_NAMES.TABELS,
    },
  ],
  TABLES_LOCATIONS: [
    {
      action: PERMISSIONS_ACTIONS.LOCATIONS,
      subject: PERMISSIONS_NAMES.TABELS,
    },
  ],
  ORIGIN_SYSTEM: [
    {
      action: PERMISSIONS_ACTIONS.WRITE,
      subject: PERMISSIONS_NAMES.ORIGIN_SYSTEM,
    },
  ],
});
